export const MODAL_TITLE = 'Histórico de férias';
export const CLOSE_LABEL = 'Fechar';
